'use client'

import { useEffect } from 'react'
import { migrateScaffoldingDefects } from '@/lib/migrate-scaffolding-defects'

export function ScaffoldingDefectsMigration() {
  useEffect(() => {
    // Run migration on mount
    migrateScaffoldingDefects()
  }, [])

  // This component doesn't render anything
  return null
}